module.exports = __webpack_public_path__ + "img/guowang2@2x.a6e5bc0f.png";